"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var loadIcon_1 = require("./loadIcon");
var S = __importStar(require("./styled"));
var Button = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? 'primary' : _b, _c = _a.buttonSize, buttonSize = _c === void 0 ? 'medium' : _c, _d = _a.block, block = _d === void 0 ? false : _d, _e = _a.variant, variant = _e === void 0 ? 'solid' : _e, _f = _a.iconDirection, iconDirection = _f === void 0 ? 'left' : _f, isLoading = _a.isLoading, Icon = _a.Icon, props = __rest(_a, ["children", "theme", "buttonSize", "block", "variant", "iconDirection", "isLoading", "Icon"]);
    var buttonBlock = react_1.default.useMemo(function () {
        if (Array.isArray(block)) {
            return {
                sm: (block === null || block === void 0 ? void 0 : block[0]) || false,
                md: (block === null || block === void 0 ? void 0 : block[1]) || (block === null || block === void 0 ? void 0 : block[0]) || false,
                lg: (block === null || block === void 0 ? void 0 : block[2]) || (block === null || block === void 0 ? void 0 : block[1]) || (block === null || block === void 0 ? void 0 : block[0]) || false,
            };
        }
        if (typeof block === 'boolean')
            return { sm: block, md: block, lg: block };
        if (typeof block === 'object') {
            return {
                sm: (block === null || block === void 0 ? void 0 : block.sm) || false,
                md: block.md || false,
                lg: block.lg || false,
            };
        }
        return { sm: false, md: false, lg: false };
    }, [block]);
    return (react_1.default.createElement(S.Button, __assign({}, props, { buttonSize: buttonSize, buttonTheme: theme, variant: variant, block: buttonBlock, iconDirection: iconDirection, ref: ref }),
        isLoading && react_1.default.createElement(loadIcon_1.LoadIcon, null),
        !isLoading &&
            Icon &&
            react_1.default.cloneElement(Icon, { className: 'iconButton' }),
        !isLoading && children));
});
exports.default = Button;
